<mat-form-field class="w-100" [hideRequiredMarker]="!attributeDefinition.isRequired">
  <mat-label>
    {{ label }}
  </mat-label>
  <input matInput type="number" [formControl]="control" [attr.id]="attributeDefinition.formControlName"
    [required]="attributeDefinition.isRequired" inputmode="numeric" autocomplete="off" step="1" min="0"
    [max]="maxAllowedValue" (keydown)="validateInput($event)" (paste)="validatePaste($event)" />
  <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)">
    {{ getErrorMessage() }}
  </mat-error>
</mat-form-field>